import { useQuery } from "@tanstack/react-query";
import getTypes from '@/services/type/get'

export const useTypes = () => {
    return useQuery({
        queryKey: ["types"],
        queryFn: getTypes,
        initialData: []
    });
};
